export interface GuidedPromptInput {
  /** A scaffold vibe word (luxury/modern/coastal/bold/minimal), or null → modern. */
  style: string | null;
  name: string;
  market: string;
}

/**
 * Assemble a whole-site scaffold prompt from the guided-onboarding answers. The
 * shape is deliberate so `parseScaffoldSite()` recognizes it AND extracts the
 * firm name cleanly: the market goes AFTER a period, outside the "for X" clause
 * that the firm-name parser reads to the end of the string.
 */
export function buildGuidedPrompt({ style, name, market }: GuidedPromptInput): string {
  const styleWord = style ?? 'modern';
  let p = `Build me a ${styleWord} real estate website`;
  if (name.trim()) p += ` for ${name.trim()}`;
  if (market.trim()) p += `. Based in ${market.trim()}.`;
  return p;
}
